import { ErrorBoundary } from 'react-error-boundary'
import { Toaster } from 'sonner'
import { Analytics } from '@vercel/analytics/react'
import { Header } from './components/Header'
import { Hero } from './components/Hero'
import { ValueCards } from './components/ValueCards'
import { About } from './components/About'
import { OurApproach } from './components/OurApproach'
import { Portfolio } from './components/Portfolio'
import { Team } from './components/Team'
import { ContactForm } from './components/ContactForm'
import { Footer } from './components/Footer'
import { ScrollProgress } from './components/ScrollProgress'
import { BackToTop } from './components/BackToTop'
import { CookieConsent } from './components/CookieConsent'
function ErrorFallback({ error, resetErrorBoundary }: { error: unknown; resetErrorBoundary: () => void }) {
  const message = error instanceof Error ? error.message : String(error)
  return (
    <div
      className="min-h-[40vh] flex flex-col items-center justify-center gap-4 px-6 py-12 bg-[#1e232b] text-center"
      role="alert"
    >
      <p className="text-white/90 font-sans">Something went wrong.</p>
      <p className="text-white/60 text-sm font-sans max-w-md">{message}</p>
      <button
        type="button"
        onClick={resetErrorBoundary}
        className="px-4 py-2 bg-[#cab6a1] text-[#1e232b] font-sans text-sm rounded hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#cab6a1] focus-visible:ring-offset-2 focus-visible:ring-offset-[#1e232b]"
      >
        Try again
      </button>
    </div>
  )
}

export default function App() {
  return (
    <>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <main className="min-h-screen font-sans overflow-x-hidden" id="main-content">
          <ScrollProgress />
          <Header />
          <Hero />
          <ValueCards />
          <About />
          <OurApproach />
          <div className="hidden" aria-hidden="true">
            <Portfolio />
            <Team />
          </div>
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <ContactForm />
          </ErrorBoundary>
          <Footer />
          <BackToTop />
          <CookieConsent />
        </main>
      </ErrorBoundary>
      <Toaster position="bottom-center" toastOptions={{ style: { background: '#1e232b', color: '#fff', border: '1px solid rgba(202,182,161,0.3)' } }} />
      <Analytics />
    </>
  )
}
